/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
// import classNames from 'classnames';
// import { FormattedMessage } from 'react-intl';
import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { Text as TextField, Select as SelectField } from '@micromag/fields';

const propTypes = {
    value: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.string,
    }),
    typeOptions: MicromagPropTypes.selectOptions,
    onChange: PropTypes.func,
};

const defaultProps = {
    value: null,
    typeOptions: [
        {
            value: 'ga',
            label: 'Universal Analytics',
            placeholder: 'UA-XXXXXX-X',
        },
        {
            value: 'ga4',
            label: 'Google Analytics 4',
            placeholder: 'G-XXXXXXX',
        },
    ],
    onChange: null,
};

const TrackingCodeField = ({ value, typeOptions, onChange }) => {
    const { type = null } = value || {};
    const typeOption = typeOptions.find(
        ({ value: tcType = null }) => type !== null && tcType === type,
    );
    const { placeholder = null } = typeOption || {};

    const onTypeChange = useCallback(
        (newFieldValue) => {
            const newValue = {
                ...value,
                type: newFieldValue,
            };
            if (onChange !== null) {
                onChange(newValue);
            }
        },
        [value, onChange],
    );

    const onIdChange = useCallback(
        (newFieldValue) => {
            const newValue = {
                ...value,
                id: newFieldValue,
            };
            if (onChange !== null) {
                onChange(newValue);
            }
        },
        [value, onChange],
    );

    return (
        <div className="row mx-n1">
            <div className="col-auto px-1">
                <SelectField
                    value={value !== null ? value.type || null : null}
                    options={typeOptions}
                    onChange={onTypeChange}
                />
            </div>
            <div className="col px-1">
                <TextField
                    value={value !== null ? value.id || null : null}
                    placeholder={placeholder}
                    onChange={onIdChange}
                />
            </div>
        </div>
    );
};

TrackingCodeField.propTypes = propTypes;
TrackingCodeField.defaultProps = defaultProps;

export default TrackingCodeField;
